import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEclipsevertDotXComponent } from './simple-icons-eclipsevert-dot-x.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEclipsevertDotXComponent ],
    exports:      [ SimpleIconsEclipsevertDotXComponent ],
    bootstrap:    []
})
export class SimpleIconsEclipsevertDotXModule {}
